import React from 'react';
import classNames from 'classnames';
import Button from 'react-bootstrap/Button';
import { FormattedMessage } from 'react-intl';
import { Spinner } from 'react-bootstrap';
import PropdocsModal from '../../../modal/PropdocsModal';
import { OptionalMessageInputRef } from '../../document-wizard-modal/custom-modals/document-wizard-action-modal/OptionalMessageInputRef';
import { TitleFormattedMessage } from '../../../titleFormattedMessage';
import { DocumentSignerWithSignedAt } from '../../../../contexts/DocumentContext';
import styles from './styles.module.scss';

interface LeaseDocumentWizardConfirmationModalProps {
  show: boolean;
  onHide: () => void;
  handleConfirm: () => void;
  isSending: boolean;
  nextSigner?: DocumentSignerWithSignedAt | null;
  optionalMessageInputRef?: React.Ref<HTMLTextAreaElement>;
}

const SEND_REMINDER_MODAL = 'Would you like to send a reminder to the next signer to complete the document signing?';

export const SendReminderConfirmationModal = ({
  show,
  nextSigner,
  onHide,
  handleConfirm,
  isSending,
  optionalMessageInputRef,
}: LeaseDocumentWizardConfirmationModalProps) => (
  <PropdocsModal
    size="lg"
    show={show}
    setShow={onHide}
    title={
      <FormattedMessage
        id="document-wizard-modal.unsign-confirmation-modal-title"
        defaultMessage="Send Reminder to Signers"
      />
    }
  >
    <>
      <section
        className={classNames('lease-document-wizard-unsign-confirmation-modal', styles.wrapper)}
        style={{ marginBottom: '1.5rem' }}
      >
        <FormattedMessage
          id="document-wizard-modal.lease-confirmation-content"
          defaultMessage={SEND_REMINDER_MODAL}
        />
      </section>
      {nextSigner && (
        <section
          className={classNames('lease-document-wizard-unsign-confirmation-modal', styles.emailWrapper)}
          style={{ marginBottom: '1.5rem' }}
        >
          <FormattedMessage
            id="document-wizard-modal.lease-confirmation-content"
            defaultMessage={`Next Signer: ${nextSigner.email}`}
          />
        </section>
      )}
      <OptionalMessageInputRef ref={optionalMessageInputRef} />

      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem', paddingTop: '1.5rem' }}>
        <Button variant="outline-warning" onClick={onHide}>
          <TitleFormattedMessage
            id="document-wizard-modal.lease-confirmation-button-cancel"
            defaultMessage="Close"
          />
        </Button>
        <Button variant="warning" onClick={handleConfirm} disabled={isSending}>
          {isSending && <Spinner animation="border" size="sm" />}
          <TitleFormattedMessage
            id="document-wizard-modal.lease-confirmation-button-remove-signature"
            defaultMessage="Confirm"
          />
        </Button>
      </div>
    </>
  </PropdocsModal>
);
